import { useContext } from 'react';
import { ErrorHandlerContext } from './ErrorHandlerProvider';
export var useErrorHandler = function () {
    var errorHandler = useContext(ErrorHandlerContext).errorHandler;
    return errorHandler;
};
